export default {
  data(){
    return {
      crossrefDebouncing: 0,
      debounceInterval: null
    }
  },
  methods: {
    getNormalizedName(givenNames, familyNames){
      const newGiven = givenNames.split(" ")[0].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      let familyName = familyNames.split(" ");
      familyName = familyName[familyName.length - 1].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return {givenName : newGiven, familyName: familyName}
    },
    fixDoi(doi){
      // remove http nonsense the user may have input
      doi = doi.replace(/https?:\/\/doi.org\/(.*?)\/?$/g,'$1');
      return (/^10.\d{4,9}\/[-._;()/:A-Z0-9]+$/i.test(doi) && doi) || null
    },
    filterAuthors(authors){
      // transforms name into lowercase, no accent 1st last name without middle names
      // then compares to similarly transformed crossref names
      // returns {authorship, authors}
      const {givenName, familyName} = this.getNormalizedName(
        this.$store.getters.user.firstName,
        this.$store.getters.user.lastName
      );
      const matches = [];
      authors.forEach(
        (author, idx) => {
          const {
            givenName: remoteAuthorGiven, 
            familyName: remoteAuthorFamily
          } = this.getNormalizedName(author.given, author.family);

          if(givenName === remoteAuthorGiven && familyName === remoteAuthorFamily){
            matches.push(idx);
          }
        }
      );
      if (matches.length !== 1){
        return {authorship: null, authors: authors}
      } else {
        let authorship;
        switch(matches[0]){
          case 0:
            authorship = 'first-author';
            break;
          case authors.length - 1:
            authorship = 'last-author';
            break;
          default:
            authorship = 'co-author'; 
        }
        authors.splice(matches[0],1);
        return {authorship, authors};
      }
    },
    getDoiData(doi){
      doi = this.fixDoi(doi)
      if(!doi){
        this.$store.dispatch(
          'showErrorSnackbar',
          'DOI inválido'
        )
        return Promise.resolve({});
      }
      
      if(this.crossrefDebouncing > 0){
        this.$store.dispatch(
          'showErrorSnackbar',
          'Too many crossref queries'
        )
        return Promise.resolve({});
      }
      this.crossrefDebouncing = 15;
      this.debounceInterval = setInterval(() => {
        this.crossrefDebouncing -= 1;
        if (this.crossrefDebouncing === 0){
          clearInterval(this.debounceInterval)
        }
      }, 1000);

      return fetch(`https://api.crossref.org/works/${doi}`)
      .then(res => {
        if (res.ok) {
          return res.json()
        } else {
          throw Error('Erro ao procurar DOI')
        }
      })
      .then(
        res => {
          let displayMessage;
          if(res.status === 'ok'){
            if (res["message-type"] === "work"){
              const ret = {};
              const message = res.message
              ret.date = message.created.timestamp;
              ret.title = message.title[0]; 
              ret['doi'] = doi
              ret['journal-name'] = message['container-title'][0];
              ret['edition-volume'] = message.volume;
              ret['year'] = message.created['date-parts'][0][0];
              ret['month'] = message.created['date-parts'][0][1];
              ret['issn'] = message['ISSN'][0];

              const {authorship, authors} = this.filterAuthors(message.author);
              ret['authorship'] = authorship;
              ret['authors'] = authors.map(author => ( `${author.family}, ${author.given}` ))
              ret['page'] = message.page
              return ret;
            } else {
              displayMessage = 'Tipo de DOI inválido';
            }
          } else {
            displayMessage = 'DOI inválido';
          }

          this.$store.dispatch(
            'showErrorSnackbar',
            displayMessage
          );
          return {}
        }
      )
      .catch(err => {
        this.$store.dispatch(
          'showErrorSnackbar',
          'Erro ao obter DOI'
        )
        return {}
      })
    }
  }
}